<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
      <el-dialog title="防汛控制点" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="设防水位" prop="sfsw">
              <el-input type="type" placeholder="设防水位" class="from-el-input" v-model.trim="ruleForm.sfsw"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="警戒水位" prop="jjsw">
              <el-input type="type" placeholder="警戒水位" class="from-el-input" v-model.trim="ruleForm.jjsw"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="保证水位" prop="bzsw">
              <el-input type="type" placeholder="保证水位" class="from-el-input" v-model.trim="ruleForm.bzsw"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="当前水位" prop="dqsw">
              <el-input type="type" placeholder="当前水位" class="from-el-input" v-model.trim="ruleForm.dqsw"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="危险指数" prop="wxzs">
              <el-input type="type" placeholder="危险指数" class="from-el-input" v-model.trim="ruleForm.wxzs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="时间" prop="fdate">
              <el-date-picker v-model.trim="ruleForm.fdate" align="right" type="date"
                value-format="yyyy-MM-dd" class="from-el-input-item" placeholder="登记日期"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="经度坐标" prop="lats">
              <el-input type="type" class="from-el-input" placeholder="经度坐标" v-model.trim="ruleForm.lngs" :disabled='true'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="纬度坐标" prop="lats">
              <el-input type="type" class="from-el-input" placeholder="纬度坐标" v-model.trim="ruleForm.lats" :disabled='true'></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="cancel()" type="warning">取消</el-button>
            <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
            <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    ydbjbxxQuery,
    kzdSave,
    kzdUpdate,
  } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  let date = new Date()
  const currentFdate = date.getFullYear() + '-' + (date.getMonth()+1) + '-'+ date.getDate() + ' ' + date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();

  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        state: '',
        ruleForm: {
          ydbName: '',
          sfsw: '',
          jjsw: '',
          bzsw: '',
          dqsw: '',
          wxzs: '',
          fdate: String(currentFdate),
          lats: '',
          lngs: ''
        },
        rules: {
          ydbName: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
          sfsw: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            }
          ],
          jjsw: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            }
          ],
          bzsw: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            }
          ],
          dqsw: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            }
          ],
          wxzs: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            }
            // {
            //   min: 1,
            //   max: 50,
            //   message: '长度在 1 到 50 个字符',
            //   trigger: 'blur'
            // }
          ],
          fdate: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 200,
              message: '长度在 1 到 200 个字符',
              trigger: 'blur'
            }
          ],
          lats: [{
            required: true,
            message: '请输入必填项',
            trigger: 'change'
          }],
          lngs: [{
            required: true,
            message: '请输入必填项',
            trigger: 'change'
          }]
        },
        row: null,
        currentData: '',
      };
    },
    created() {
      //初始化数据
    },
    components: {
      addressTree
    },
    methods: {
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbName = res.data[0].ydbName;
            _this.ruleForm.lngs = res.data[0].ydbJingDu;
            _this.ruleForm.lats = res.data[0].ydbWeiDu;
          }
        })
      },
      treeClose() {
        // let params = {};
        // this.list(params);
      },
      objdata(data) {
        let params = {
          ydbCode: data.ydbCode
        };
        this.list(params);
      },
      cancel() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      deteRmine(formName, state) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (state == 'xz') {
              let params = {
                ydbName: this.ruleForm.ydbName, //淤地坝名称
                ydbCode: this.ruleForm.ydbCode, //淤地坝编号
                ydbSfsw: this.ruleForm.sfsw, //设防水位
                ydbJjsw: this.ruleForm.jjsw, //警戒水位
                ydbBzsw: this.ruleForm.bzsw, //保证水位
                ydbDqsw: this.ruleForm.dqsw, //当前水位
                ydbWxzs: this.ruleForm.wxzs, //危险指数
                ydbShiJian: this.ruleForm.fdate, //时间
                ydbJingDu: this.ruleForm.lngs, //经度
                ydbWeiDu: this.ruleForm.lats, //纬度
              };
              kzdSave(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("adddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            } else {
              let params = {
                ydbName: this.ruleForm.ydbName, //淤地坝名称
                ydbCode: this.ruleForm.ydbCode, //淤地坝编号
                ydbSfsw: this.ruleForm.sfsw, //设防水位
                ydbJjsw: this.ruleForm.jjsw, //警戒水位
                ydbBzsw: this.ruleForm.bzsw, //保证水位
                ydbDqsw: this.ruleForm.dqsw, //当前水位
                ydbWxzs: this.ruleForm.wxzs, //危险指数
                ydbShiJian: this.ruleForm.fdate, //时间
                ydbJingDu: this.ruleForm.lngs, //经度
                ydbWeiDu: this.ruleForm.lats, //纬度
                id: this.row.id
              };
              kzdUpdate(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("bjadddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            }
          }
        });
      },

      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
    },
    mounted() {
      //实例挂载后
      this.state = this.mystate[0];
      this.row = this.mystate[1];
      if (this.state == 'bj') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbName = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.sfsw = this.mystate[1].ydbSfsw; //设防水位
        this.ruleForm.jjsw = this.mystate[1].ydbJjsw; //警戒水位
        this.ruleForm.bzsw = this.mystate[1].ydbBzsw; //保证水位
        this.ruleForm.dqsw = this.mystate[1].ydbDqsw; //当前水位
        this.ruleForm.wxzs = this.mystate[1].ydbWxzs; //危险指数
        this.ruleForm.fdate = this.mystate[1].ydbShiJian; //时间
        this.ruleForm.lngs = this.mystate[1].ydbJingDu; //经度
        this.ruleForm.lats = this.mystate[1].ydbWeiDu; //纬度
      }
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 800px;
  }

  >>>.el-dialog__body {
    height: 300px;
    overflow: auto;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }

</style>
